<template>
  <el-form>
    <div class="row">
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('search')"
          class="material-style"
        >
          <select-response-auto-complete
            :model="value"
            @update:model="$emit('input', $event)"
            @on-data-value="handleDataValue"
            :columns="columns"
            api="Parts/GetAllDynamic"
            :selected="selected"
            searchAllColumns
            :fields="{id: 'id', title: 'partNumber'}"
          >
          </select-response-auto-complete>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { filterStartsWith } from '@/utils/shared'

export default {
  name: 'TopPanel',
  props: {
    value: { default: null }
  },
  computed: {
    selected () {
      return [
        'id', 'partNumber', 'partDescription', 'remark'
      ].join(',')
    },
    columns () {
      return [
        { title: this.L10n('part-number'), value: 'partNumber', originField: 'partNumber', type: 'custom', customFilter: filterStartsWith },
        { title: this.L10n('part-description'), value: 'partDescription', originField: 'partDescription', type: 'custom', customFilter: filterStartsWith },
        { title: this.L10n('remark'), value: 'remark' }
      ]
    }
  },
  methods: {
    handleDataValue (value) {
      this.$emit('onCameData', value)
    }
  }
}
</script>
